import type { SidebarSectionDef } from "./items"
import { texts } from "./localization/texts"
import { SidebarRow } from "./SidebarRow"

type SidebarSectionProps = {
  section: SidebarSectionDef
  isCollapsed?: boolean
  activeHref?: string | null
}

export function SidebarSection({
  section,
  isCollapsed = false,
  activeHref = null
}: SidebarSectionProps) {
  return (
    <section className="flex flex-col gap-1 mt-2">
      {isCollapsed ? null : (
        <h2 className="font-gochi px-1 font-normal text-white/75 antialiased [font-synthesis:none]">
          {texts.sections[section.id]}
        </h2>
      )}
      <ul className="flex flex-col">
        {section.rows.map((row) => (
          <li key={row.id}>
            <SidebarRow
              row={row}
              isCollapsed={isCollapsed}
              isActive={row.href !== null && row.href === activeHref}
            />
          </li>
        ))}
      </ul>
    </section>
  )
}
